import {useTranslation} from "react-i18next";
import "./Footer.css";

const Footer = () => {
    const {t} = useTranslation();

    return (
        <footer className="Footer">
            <div className="Footer-links">
                <a href="https://gouspa.org/privacy-policy">{t("footer.privacyPolicy")}</a>
                <span className="Footer-separator">|</span>
                <a href="https://gouspa.org/images-policy">{t("footer.imagesPolicy")}</a>
            </div>
            <p className="Footer-disclaimer">
                {t("footer.disclaimer")}
            </p>
        </footer>
    );
};

export default Footer;
